// extracted by mini-css-extract-plugin
export default {"container":"CanvasFloorViewer_container__Wajrt","canvas":"CanvasFloorViewer_canvas__qBZzI","floorBadge":"CanvasFloorViewer_floorBadge__OkLHA"};